import { List, useTable } from '@refinedev/antd';
import { IBook } from '../../interfaces/book';
import { HttpError } from '@refinedev/core';
import { Table } from 'antd';
import { ISitter } from '../../interfaces/sitter';

const fields = [
  'id',
  'title',
  'author',
  'publisher',
  'abstract',
  'outline',
  'imageReference',
  'pick',
  {
    image: ['id', 'url'],
  },
];

export const BookList = () => {
  const { tableProps } = useTable<IBook, HttpError>({
    resource: 'books',
    meta: { fields },
  });

  return (
    <List>
      <Table {...tableProps}>
        <Table.Column dataIndex="id" title="ID" />
        <Table.Column dataIndex="title" title="タイトル" />
        <Table.Column<IBook>
          dataIndex="image"
          title="画像"
          render={(value, record) => <img src={value.url} alt="avatar" width={100} />}
        />
        <Table.Column dataIndex="author" title="著者" />
        <Table.Column dataIndex="publisher" title="出版社" />
        <Table.Column dataIndex="abstract" title="概要" />
        <Table.Column dataIndex="outline" title="あらすじ" />
        <Table.Column dataIndex="imageReference" title="引用元" />
        <Table.Column dataIndex="pick" title="特集" />
      </Table>
    </List>
  );
};
